import api from '../token';

export const ListCambio = async () => {
  try {
    const response = await api.post('/getCambio');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

